export default "__VITE_ASSET__SGf76tre__"